import account from './account/store/reducer'
import appSettings from './appSetting/store/reducer'
import language from './language/store/reducer'
import pages from './pages/store/reducer'
import tenants from './tenant/store/reducer'
import roles from './role/store/reducer'
import themes from './theme/store/reducer'

export default { account, appSettings, language, pages, tenants, roles, themes }